import { gql } from "@apollo/client";

export const COMPANY_FRAGMENT = gql`
    fragment companiesFragment on Company {
        id
        name
    }
`

export const GET_COMPANIES = gql`
    ${COMPANY_FRAGMENT}
    query GetCompanies {
        companies {
            ...companiesFragment
        }
    }
`;
